import { MapPin } from "lucide-react";

export default function ProjectCard({ project, onSelect, className = "" }) {
  return (
    <button
      onClick={() => onSelect?.(project)}
      data-testid={`project-card-${project.id}`}
      className={`group relative block w-full overflow-hidden rounded-xl text-left spotlight-frame ${className}`}
    >
      <img
        src={project.image}
        alt={project.name}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-obsidian/90 via-obsidian/20 to-transparent transition-opacity duration-500" />
      <div className="absolute inset-0 rounded-xl ring-1 ring-inset ring-gold/0 transition-all duration-500 group-hover:ring-gold/40" />
      <div className="relative flex h-full min-h-[300px] flex-col justify-end p-6">
        <span className="mb-3 w-fit rounded-full border border-gold/40 bg-obsidian/60 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-gold-soft backdrop-blur-sm">
          {project.category}
        </span>
        <p className="flex items-center gap-1.5 text-xs uppercase tracking-[0.15em] text-stone-400">
          <MapPin className="h-3 w-3 text-gold" />
          {project.location}
        </p>
      </div>
    </button>
  );
}
